import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { showModal } from 'src/modules/shared/modal/actions';
import { useClearFilters } from 'src/modules/search/hooks';
import PostList from 'src/modules/shared/resultsList/components/postList';
import PostListLoader from 'src/modules/shared/resultsList/components/postListLoader';
import CommunityFilterOptions from 'src/modules/search/posts/components/communityFilterOptions';
import Pagination from 'src/components/pagination/pagination';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';
import { ModalType } from 'src/constants/modalTypes';
import { ResultsContainer, ResultsContent, ResultsSidebar } from 'styles-js/resultsList';
import { EmptyState, EmptyStateCount, QueryText } from 'src/modules/tag/sharedStyles';
import { LinkButton } from 'styles-js/buttons';
export default function TagPostsList(): JSX.Element {
  const dispatch = useDispatch();
  const clearFilters = useClearFilters();
  const {
    communityFilterOptions,
    isLoading,
    results,
    tagName,
    totalResults
  } = useSelector(({
    pages
  }) => pages.tag.posts);
  const showFilterModal = () => {
    dispatch(showModal({
      modalType: ModalType.TagFilterOptions
    }));
  };
  const renderEmptyState = () => {
    return <EmptyState data-sentry-element="EmptyState" data-sentry-component="renderEmptyState" data-sentry-source-file="tagPostsList.tsx">
        <EmptyStateCount data-sentry-element="EmptyStateCount" data-sentry-source-file="tagPostsList.tsx">0 {i18n.t('public')} {i18n.t('posts')}</EmptyStateCount>
        <div>
          {i18n.t("Sorry, we don't have any public ")} {i18n.t('posts')} {i18n.t(' matching ')}
          <QueryText data-sentry-element="QueryText" data-sentry-source-file="tagPostsList.tsx">{tagName}</QueryText>
        </div>
      </EmptyState>;
  };
  const renderResultsCount = () => {
    const count = Number(totalResults).toLocaleString();
    const typeOfPost = i18n.t('public');
    const postLabel = totalResults === 1 ? i18n.t('post') : i18n.t('posts');
    return `${count} ${typeOfPost} ${postLabel}`;
  };
  return <ResultsContainer data-sentry-element="ResultsContainer" data-sentry-component="TagPostsList" data-sentry-source-file="tagPostsList.tsx">
      <ResultsContent data-sentry-element="ResultsContent" data-sentry-source-file="tagPostsList.tsx">
        {isLoading ? <PostListLoader /> : totalResults === 0 ? renderEmptyState() : <>
                <div className="search__summary-row">
                  <div>{renderResultsCount()}</div>
                  <LinkButton className="mobile-filter-modal" onClick={showFilterModal}>
                    {i18n.t('Filter results')}
                  </LinkButton>
                </div>

                <PostList posts={results} />

                <Pagination isShowBotLinks={true} lastPageOverride={100} pageSize={paginationResultsPerPage.search} total={totalResults} />
              </>}
      </ResultsContent>

      <ResultsSidebar data-sentry-element="ResultsSidebar" data-sentry-source-file="tagPostsList.tsx">
        <div className="search__sidebar filter-options">
          <div className="filter-header">
            <div className="filter-title">{i18n.t('Filter results')}</div>
            <LinkButton onClick={clearFilters} data-sentry-element="LinkButton" data-sentry-source-file="tagPostsList.tsx">{i18n.t('Clear filters')}</LinkButton>
          </div>
          <CommunityFilterOptions communityFilterOptions={communityFilterOptions} data-sentry-element="CommunityFilterOptions" data-sentry-source-file="tagPostsList.tsx" />
        </div>
      </ResultsSidebar>
    </ResultsContainer>;
}